var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportar }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _vm._v(" "),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("k-table", {
        ref: "listaImpuestos",
        attrs: {
          filterStatus: _vm.filterStatus,
          createButton: _vm.createButton,
          editButton: false,
          deleteButton: false,
          path: _vm.url + "/impuestos/search",
          columns: [
            {
              display: "Código",
              value: "id_tarifa"
            },
            {
              display: "Descripción",
              value: "descripcion"
            },
            {
              display: "Porcentaje",
              value: "porcentaje"
            },
            {
              display: "T. específica",
              value: "tarifa_especifica"
            },
            {
              display: "Unidades",
              value: "numero_unidades"
            },
            {
              display: "T. Ed valorem",
              value: "tarifa_ed_valorem"
            },
            {
              display: "Retención",
              value: "descripcion_aplica_retencion"
            },
            {
              display: "Fecha Habilitación",
              value: "fecha_habilitacion"
            }
          ]
        },
        on: { crear: _vm.crear, seleccionar: _vm.seleccionar }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "impuesto"
          }
        },
        [
          _c("item", {
            attrs: { searchButton: _vm.searchButton },
            on: { created: _vm.createdImpuesto }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Impuestos")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d3ca4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d3ca4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/impuestos/ListaImpuestos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-10d3ca4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/impuestos/ListaImpuestos.vue
// module chunks = 0